import Swiper from "swiper";
import { Navigation, Pagination, Manipulation } from "swiper/modules";

import "./index.css";

export function setupSwiper() {
  // corporate freestyle
  const corporateSwiper = document.querySelector(
    ".freestyle-corporate-gallery-swiper"
  );

  if (corporateSwiper != null) {
    new Swiper(corporateSwiper as HTMLElement, {
      slidesPerView: 1,
      spaceBetween: 24,
      autoHeight: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1104: {
          slidesPerView: 3,
        },
      },
      modules: [Navigation, Pagination, Manipulation],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}
